export default __webpack_public_path__ + "static/media/ecofunding.2fa1773a.png";